import { createAction } from 'redux-actions';

export const MODAL_CONFIRM_NO = 'MODAL_CONFIRM_NO';

export default createAction(MODAL_CONFIRM_NO);
